import React from "react";
import StackNavigator from "../../components/StackNavigator";
import Order from "./Order";
import Orders from "./Orders";

function OrderScreens() {
  const SCREENS = [
    { name: "ordersscreen", component: Orders },
    { name: "order", component: Order },
  ];
  return <StackNavigator screens={SCREENS} />;
}

export default OrderScreens;
